import { NotificationConstants } from "../constants";

export const updateNotification = (payload) => ({
  type: NotificationConstants.UPDATE_NOTIFICATION,
  payload,
});
